import pick from 'utils/pick';

import { PLACEHOLDER_IDENTITY_KEYS as omittedKeys } from '../../template/styleMerge';

// TODO Use pick instead of omit.
// - It would require creating this function for each placeholder type,
//   which might now be a little overcomplicated.

/**
 * Gets placeholder specification properties.
 * The basic placeholder values (data, id, override, type) that can sometimes
 * be present in the override object are removed.
 * Always read them directly from the placeholder,
 * where they are always defined with no need to override.
 * @param {object} placeholder Parabo placeholder or placeholder style
 * @returns {object}
 */
const getPlaceholderSpec = placeholder => {
  const keys = Object.keys(placeholder).filter(key => !omittedKeys.includes(key));
  return pick(placeholder, ...keys);
};

export default getPlaceholderSpec;
